import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../assets/style-helpers.scss';

export const templateWebAccessControlScheduler = document.createElement('template');

templateWebAccessControlScheduler.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <style>${styleHelpersStyles}</style>
  <div class="wrapper">
      <div class="content">
            <div class="grid">
                <gz-grid-view class="grid-view">
                    <div class="header__actions" slot="grid-header-actions-slot">
                        <gz-button id="addScheduleBtn" class="mr-2"></gz-button>
                        <gz-button id="deleteBtn" type="outline" color="negative" buttonfontsize="medium" disabled></gz-button>
                    </div>
                </gz-grid-view>
            </div>
      </div>
  </div>

  <gz-web-access-control-scheduler-form class="scheduler-form"></gz-web-access-control-scheduler-form>
`;
